import styled from 'styled-components';
interface IndicatorsContainerProps {
  hasButton: boolean;
}

export const IndicatorsContainer = styled.div<IndicatorsContainerProps>`
  gap: 8px;
  padding-top: 6px;
  padding-left: ${(props) => (props.hasButton ? '0px' : '73px')};
  min-height: 50px;
  max-height: 80px;
  box-sizing: border-box;
`;
export const IndicatorItem = styled.div`
  display: flex;
  gap: 8px;
  width: auto;
  height: auto;
`;
export const IndicatorIcon = styled.img`
  width: 16px;
  height: 16px;
  vertical-align: middle;
`;
export const IndicatorText = styled.p`
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  padding-top: 2px;
  display: inline-block;
`;